<template>
  <p class="alert alert-danger">
    <i class="fa fa-trash"></i>
    <slot />
    <button class="btn btn-danger" tabindex="-1" type="button" @click="$emit('restore')">Restore</button>
  </p>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
  },
}
</script>
